import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export function SubscriptionAgreement() {
  const { language, t } = useLanguage();
  const navigate = useNavigate();
  const [returnTo, setReturnTo] = useState(null);

  useEffect(() => {
    const checkoutReturnTo = localStorage.getItem('checkoutReturnTo');
    if (checkoutReturnTo) {
      setReturnTo(checkoutReturnTo);
    }
  }, []);

  const handleBackClick = () => {
    if (returnTo) {
      window.location.href = returnTo;
    } else {
      navigate(`/${language}/`);
    }
  };


  const backText = returnTo 
    ? (t('checkout.btnBack') || 'Back') + ' to checkout'
    : t('subscriptionPolicy.backToHome') || 'Back to home';

  return (
    <div className="min-h-screen bg-slate-950">
      <div className="max-w-4xl mx-auto px-6 py-16">
        <button 
          onClick={handleBackClick}
          className="text-primary hover:text-purple-400 transition-colors mb-8 inline-block cursor-pointer bg-transparent border-none"
        >
          ← {backText}
        </button>
        
        <h1 className="text-4xl font-heading font-bold text-white mb-8">
          {t('subscriptionPolicy.title')}
        </h1>

        <div className="prose prose-invert prose-slate max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {t('subscriptionPolicy.infraSupportTitle')}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-4">
              {t('subscriptionPolicy.infraSupportText')}
            </p>
            <ul className="space-y-2 text-slate-300">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>{t('subscriptionPolicy.techStability')}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>{t('subscriptionPolicy.continuousMaintenance')}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>{t('subscriptionPolicy.minorAdjustments')}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>{t('subscriptionPolicy.monitoring')}</span>
              </li>
            </ul>
            <div className="mt-6 p-4 bg-slate-900/50 border border-slate-800 rounded-lg">
              <p className="text-white font-semibold">
                {t('subscriptionPolicy.standardRate')}
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {t('subscriptionPolicy.discountedRateTitle')}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-4">
              {t('subscriptionPolicy.discountedRateText')}
            </p>
            <div className="bg-primary/10 border border-primary/20 rounded-lg p-6">
              <p className="text-white mb-2">
                {t('subscriptionPolicy.minimumTerm')}
              </p>
              <p className="text-slate-300">
                {t('subscriptionPolicy.discountedRateNote')}
              </p>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {t('subscriptionPolicy.billingStructureTitle')}
            </h2>
            <ul className="space-y-3 text-slate-300">
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>{t('subscriptionPolicy.billing30Days')}</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="text-primary mt-1">•</span>
                <span>{t('subscriptionPolicy.billingStripe')}</span>
              </li>
            </ul>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {t('subscriptionPolicy.earlyExitTitle')}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-4">
              {t('subscriptionPolicy.earlyExitText')}
            </p>
            <p className="text-slate-400">
              {t('subscriptionPolicy.earlyExitNote')}
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-semibold text-white mb-4">
              {t('subscriptionPolicy.postCommitmentTitle')}
            </h2>
            <p className="text-slate-300 leading-relaxed mb-4">
              {t('subscriptionPolicy.postCommitmentText')}
            </p>
            <p className="text-slate-400">
              {t('subscriptionPolicy.postCommitmentNote')}
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800">
          <p className="text-sm text-slate-500">
            {t('subscriptionPolicy.lastUpdated')}
          </p>
        </div>
      </div>
    </div>
  );
}
